var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1538 14.1109H19.8974C19.0154 14.1109 18.2256 13.6164 17.8359 12.8333L17.4872 12.1327C16.8308 10.8139 15.5179 10 14.0513 10H11.8462C9.72308 10 8 11.7309 8 13.8636V23.1364C8 25.2691 9.72308 27 11.8462 27H24.1538C26.2769 27 28 25.2691 28 23.1364V17.9848C28 15.8521 26.2769 14.1212 24.1538 14.1212V14.1109ZM26.4615 23.1261C26.4615 24.4036 25.4256 25.4442 24.1538 25.4442H11.8462C10.5744 25.4442 9.53846 24.4036 9.53846 23.1261V13.8533C9.53846 12.5758 10.5744 11.5352 11.8462 11.5352H14.0513C14.9333 11.5352 15.7231 12.0297 16.1128 12.8127L16.4615 13.5133C17.1179 14.8321 18.4308 15.6461 19.8974 15.6461H24.1538C25.4256 15.6461 26.4615 16.6867 26.4615 17.9642V23.1158V23.1261Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon);
export default __webpack_public_path__ + "static/media/media-icon.e28da650.svg";
export { ForwardRef as ReactComponent };